import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { defer, filter, map, Observable, of, shareReplay } from 'rxjs';

import { Environment, ENVIRONMENT } from '@environment';
import { UsheruApi } from '@usheru-hff/shared/data-access-backend';
import { Language } from '@usheru-hff/shared/domain';
import { Genre } from '@usheru-hff/shared/domain/genre';
import { notUndefined } from '@usheru-hff/shared/utils';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly usheruApi = inject(UsheruApi);
  private readonly http = inject(HttpClient);
  private readonly env = inject(ENVIRONMENT);
  private readonly headers = this.usheruApi.getStandardHeader();

  private languages$ = defer(() =>
    this.http.get<Language[]>(this.env.api.languagesUrl(), { headers: this.headers })
  ).pipe(shareReplay(1));

  getLanguages(): Observable<Language[]> {
    return this.languages$;
  }

  getLanguageFromCode(code: string): Observable<Language | undefined> {
    if (!code) return of(undefined);

    return this.languages$.pipe(
      filter(notUndefined),
      map(languages => languages?.find(lang => lang.code == code))
    );
  }
}
